import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Meta } from 'common/components/meta';
import { getCanonicalURL } from 'common/utils';
import DriftChat from 'common/containers/drift_chat';
import { fetchCategoriesIfNeeded } from 'common/ducks/categories';
import { fetchReviewStatsIfNeeded } from 'marketing/ducks';
import { ORGANIZATION } from 'marketing/metadata';
import HomeContent from 'marketing/components/home_content';

const METADATA = `
<script type="application/ld+json">
  {
    "@context": "http://schema.org/",
    ${ORGANIZATION}
  };

  {
    "@context": "http://schema.org/",
    "@type": "SiteNavigationElement",
    "hasPart": {
      "@type": "WebPage",
      "url": "https://www.crowdspring.com/categories/",
    },
    "hasPart": {
      "@type": "WebPage",
      "url": "https://www.crowdspring.com/explore/",
    },
    "hasPart": {
      "@type": "WebPage",
      "url": "https://www.crowdspring.com/how-it-works/",
    },
    "hasPart": {
      "@type": "WebPage",
      "url": "https://www.crowdspring.com/reviews/",
    },
    "hasPart": {
      "@type": "WebPage",
      "url": "https://www.crowdspring.com/pricing/",
    },
    "hasPart": {
      "@type": "WebPage",
      "url": "https://www.crowdspring.com/agencies/",
    },
    "hasPart": {
      "@type": "WebPage",
      "url": "https://www.crowdspring.com/1to1-projects/",
    },
    "hasPart": {
      "@type": "WebPage",
      "url": "https://www.crowdspring.com/blog/",
    }
  };
</script>
`;

export default class Home extends Component {
  render() {
    return (
      <div className="l-content" id="content">
        <Meta
          title="Logos, Website, Graphic Design, Product Design, Naming & More"
          meta={[{name: "description", content: "World's most trusted marketplace for graphic design, including logo design, website design, product design and naming your business. 100% money-back guarantee!"}]}
          link={[{ rel: 'canonical', href: getCanonicalURL("/") }]} />
        <span dangerouslySetInnerHTML={{ __html: METADATA }} />
        <HomeContent />
        <DriftChat />
      </div>
    );
  }
};

Home.need = [fetchCategoriesIfNeeded, fetchReviewStatsIfNeeded];
